import { googleMapService } from '@/helpers/services/googleMap.service';
import { sharedHelper } from '@/utils'

export const state = {
    list: {
        data: [],
    },
    currentLocation: []
}

export const GOOGLE_MAPS_MODULE = 'googleMap';

// define action 
export const SEARCH_PLACES = 'searchPlaces';
export const GET_CURRENT_LOCATION = 'getCurrentLocation';
export const CLEAR_LOCATION = 'clearLocation';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const SEARCH_PLACES_REQUEST = "searchPlaces";
const GET_CURRENT_LOCATION_REQUEST = "getCurrentLocation";
const CLEAR_PLACES = "clearPlaces";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [SEARCH_PLACES]({ commit }, { data }) {
        await googleMapService
            .searchPlaces(data)
            .then(
                (result) => {
                    commit(SEARCH_PLACES_REQUEST, result.places)
                },
                (error) => {
                    console.log('Google Maps Error: ' + error);
                }
            )
    },
    // eslint-disable-next-line no-unused-vars
    async [GET_CURRENT_LOCATION]({ commit }) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const lat = position.coords.latitude;
                    const lon = position.coords.longitude;

                    const latOffset10 = 10 / 111;
                    const lonOffset10 = 10 / (111 * Math.cos(lat * (Math.PI / 180)));
                    
                    var data = [];
                    data['latitude'] = position.coords.latitude;
                    data['longitude'] = position.coords.longitude;
                    data['borderLatitude'] = lat + latOffset10;
                    data['borderLongitude'] = lon + lonOffset10;

                    commit(GET_CURRENT_LOCATION_REQUEST, data)
                },
                error => {
                    console.error("Error getting location:", error.message);
                    alert("Could not retrieve your location. Please enable location services.");
                }
            );
        }
        else {
            console.log('Error: Geolocation is not supported');
        }
    },
    [CLEAR_LOCATION]({commit}) {
        commit(CLEAR_PLACES);
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [SEARCH_PLACES_REQUEST](state, data) {
        let d = data

        state.list.data = d.map((place) => {
            return {
                id: place.id,
                displayName: place.displayName ? place.displayName.text : "Unknown", // 🆕 Display Name
                formattedAddress: place.formattedAddress || "No Address",
                cleanedAddress: sharedHelper.cleanAddress(place.formattedAddress, place.addressComponents),
                addressLines: sharedHelper.extractAddressLines(place.addressComponents),
                latitude: place.location ? place.location.latitude : "N/A",
                longitude: place.location ? place.location.longitude : "N/A",
                city: sharedHelper.getAddressComponent(place.addressComponents, "locality"),
                state: sharedHelper.getAddressComponent(place.addressComponents, "administrative_area_level_1"),
                postcode: sharedHelper.getAddressComponent(place.addressComponents, "postal_code"),
                country: sharedHelper.getAddressComponent(place.addressComponents, "country"),
            }
        });
    },
    [GET_CURRENT_LOCATION_REQUEST](state, data) {
       state.currentLocation = data;
    },
    [CLEAR_PLACES](state) {
        state.list.data = [];
    }
}


export default {
    namespaced: true,
    state,
    actions,
    mutations,
};